module.exports = __webpack_public_path__ + "img/public/siteImages/superSliderBg.png?cb8be118";